import React, { useCallback, useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { usePayment } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import {
  AdditionalPayment,
  ChoosePayment,
  CurrentPayment,
  NowPayments,
  PaymentModalWrapper,
} from 'modules/PaymentsPage/components'

import { selectLocaleDict } from 'features/locale/selectors'

import { additionalDepositSystems } from 'pages/ProfilePage/data/utils'

import './Payment.scss'

const b = block('payment')

export const Payment: React.FC<{ path: string }> = ({ path }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).payment

  const {
    type,
    currentSlug,
    additionSlug,
    selected,
    setSelected,
    isNowPayments,
    currentFormattedSystem,
    systems: {
      formatted: { systemsList },
      communications: {
        isLoading
      }
    }
  } = usePayment({ includeCrypto: true, autoSelected: false })

  const handleChangeSystem = useCallback((value: string): void => {
    setSelected(value)
  }, [setSelected])

  const onBackClick = useCallback(() => {
    if (additionSlug) {
      setSelected(currentSlug)
    } else {
      setSelected('')
    }
  }, [additionSlug, currentSlug, setSelected])

  const filteredSystemList = useMemo(
    () =>
      [...systemsList, ...additionalDepositSystems],
    [systemsList],
  )

  const currentPaymentComponent = useMemo(() => {
    let component = null

    const findAdditionData = additionalDepositSystems.find(s => s.slug === selected)

    if (isNowPayments) {
      component = (
        <NowPayments changeSystem={handleChangeSystem} selected={selected} type={type} />
      )
    } else if (findAdditionData?.slug) {
      component = (
        <AdditionalPayment
          paymentType={type}
          systemItem={findAdditionData}
          locale={locale}
          changeSystem={handleChangeSystem}
        />
      )
    } else if (selected) {
      component = (
        <CurrentPayment
          selectedSystem={selected}
          paymentType={type}
          changeSystem={handleChangeSystem}
        />
      )
    }
    return component
  }, [isNowPayments, selected, handleChangeSystem, locale, type])

  return (
    <PaymentModalWrapper
      path={path}
      paymentType={type}
      system={currentFormattedSystem}
      onBackClick={onBackClick}>
      <div className={b()}>
        {!selected ? (
          <ChoosePayment
            changeSystem={handleChangeSystem}
            systemList={filteredSystemList}
            isLoading={isLoading}
          />
        ) : (
          currentPaymentComponent
        )}
      </div>
    </PaymentModalWrapper>
  )
}
